// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPicRightOutlinedSvg from "@fishx/icons-svg/es/asn/PPicRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PPicRightOutlined = function PPicRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPicRightOutlinedSvg
  }));
};

PPicRightOutlined.displayName = 'PPicRightOutlined';
export default React.forwardRef(PPicRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPicRightOutlined.js
// module id = 3538
// module chunks = 0